import { Stack, Typography } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid-premium'
import Link from 'next/link'
import { BaseColumnConfig } from '../types'
import { baseColumnConfig } from './baseColumnConfig'
import type { GridValidRowModel } from '@mui/x-data-grid/models/gridRows'

export type HyperlinkColumnConfig<T extends GridValidRowModel> = BaseColumnConfig<T, 'hyperlink'> & {
  columnType: 'hyperlink'
}

export const getLinkColumn = <T extends GridValidRowModel>({
  columnType,
  style,
  ...config
}: HyperlinkColumnConfig<T>): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  groupable: false,
  renderCell: (params) => (
    <Stack
      direction="row"
      alignItems="center"
      height="100%"
      {...(config?.getDataTestId ? { ['data-testid']: config.getDataTestId(params) } : {})}
    >
      <Link target="_blank" rel="noopener noreferrer" href={params.value || ''} style={{ width: '100%', display: 'block' }}>
        <Typography
          color="primary"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {params.value || ''}
        </Typography>
      </Link>
    </Stack>
  ),
})
